import MuiTab from '@mui/material/Tab';

import { getTypographyStyles, styled } from 'helpers';

import { TableTabProps } from './';

export const TableTab = styled(MuiTab)<TableTabProps>`
  ${({ theme }) => getTypographyStyles('body1', theme)}

  color: ${({ theme }) => theme.palette.blueGrey['A600']};
  min-height: 44px;
  min-width: 162px;
  padding: ${({ theme }) => theme.spacing(1.25)};
  ${({ theme }) => theme.spacing(2)};

  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
  }

  &.Mui-selected {
    background: ${({ theme }) => theme.palette.background.paper};
    color: ${({ theme }) => theme.palette.text.primary};
  }

  &.MuiTab-fullWidth {
    min-width: 0;
  }
`;
TableTab.displayName = 'TableTab';

export default TableTab;
